import React from 'react';
import './MarqueeBar.css';

interface MarqueeBarProps {
    items: string[];
    variant?: 'top' | 'features';
}

const MarqueeBar: React.FC<MarqueeBarProps> = ({ items, variant = 'top' }) => {
    const content = [...items, ...items];

    return (
        <div className={`marquee-bar marquee-bar--${variant}`} aria-hidden="true">
            <div className="marquee-bar__track">
                {content.map((item, index) => (
                    <span key={`${item}-${index}`} className="marquee-bar__item">
                        <span className="marquee-bar__star">✦</span>
                        {item}
                    </span>
                ))}
            </div>
        </div>
    );
};

export default MarqueeBar;
